import { Trans } from "@lingui/react/macro";
import { createFileRoute } from "@tanstack/react-router";

import { AccountSecurityBanner } from "@/components/account/account-security-banner";
import { VerificationDocuments } from "@/components/account/provider/profile/verification-documents";

/**
 * Provider identity verification page — dedicated URL for the photo-gallery
 * verify CTA + any other deep-links pointing at `/account/provider/verification`.
 *
 * Wraps the full-mode `VerificationDocuments` widget (progress bar + 5 slots +
 * upload + DataSecurityBanner). The same widget is also embedded inside the
 * profile editor and the registration wizard (compact mode).
 */
export const Route = createFileRoute("/_authenticated/account/provider/verification")({
  component: VerificationPage,
});

function VerificationPage() {
  return (
    <div className="space-y-6">
      <header>
        <h1 className="font-display text-foreground text-2xl font-semibold tracking-[-0.02em]">
          <Trans>Identity verification</Trans>
        </h1>
        <p className="text-muted-foreground mt-1 text-sm">
          <Trans>
            Upload your medical license, ID, and supporting documents — our medical team reviews
            them within 24 hours.
          </Trans>
        </p>
      </header>

      <VerificationDocuments />

      <AccountSecurityBanner />
    </div>
  );
}
